// eslint-disable-next-line import/no-extraneous-dependencies
import React from 'react';
import { BiomarkerPanelType } from './BiomarkerResults.api';
export function formatReportDataForSelectItem(data) {
    return data.map(function (item) {
        var _a, _b, _c, _d, _e, _f, _g, _h, _j, _k, _l, _m, _o;
        var titleParts = [
            item.reportDate ? (_a = item.reportDate) === null || _a === void 0 ? void 0 : _a.toLocaleDateString() : 'No report date',
        ];
        if (item.type === BiomarkerPanelType.Panel) {
            if ((_b = item.panel) === null || _b === void 0 ? void 0 : _b.panelName) {
                titleParts.push((_c = item.panel) === null || _c === void 0 ? void 0 : _c.panelName);
            }
            if ((_d = item.panel) === null || _d === void 0 ? void 0 : _d.collectionSite) {
                titleParts.push((_e = item.panel) === null || _e === void 0 ? void 0 : _e.collectionSite);
            }
        }
        else if (item.type === BiomarkerPanelType.PanelOrder) {
            if ((_f = item.panelOrder) === null || _f === void 0 ? void 0 : _f.panelName) {
                titleParts.push((_g = item.panelOrder) === null || _g === void 0 ? void 0 : _g.panelName);
            }
            if ((_h = item.panelOrder) === null || _h === void 0 ? void 0 : _h.accessionNumber) {
                titleParts.push((_j = item.panelOrder) === null || _j === void 0 ? void 0 : _j.accessionNumber);
            }
            if ((_k = item.panelOrder) === null || _k === void 0 ? void 0 : _k.collectionSite) {
                titleParts.push((_l = item.panelOrder) === null || _l === void 0 ? void 0 : _l.collectionSite);
            }
        }
        var label = titleParts.join(' - ');
        return {
            label: label,
            value: ((_m = item.panel) === null || _m === void 0 ? void 0 : _m.id) || ((_o = item.panelOrder) === null || _o === void 0 ? void 0 : _o.id) || label,
        };
    });
}
export var BiomarkerResultsContext = React.createContext({
    hasMolecularRecommendationsPermission: false,
    selectedBiomarkerIds: [],
    onSelectBiomarker: function () { },
    onDeselectBiomarker: function () { },
    disableQueueItems: false,
});
export var getSelectedPanelFromComboboxItemValue = function (data, selected) { return data.find(function (item) { var _a, _b; return ((_a = item.panel) === null || _a === void 0 ? void 0 : _a.id) === selected || ((_b = item.panelOrder) === null || _b === void 0 ? void 0 : _b.id) === selected; }); };
